import {
    BACK_IN_STOCK_DISPLAY,
    Product,
    ProductItemBundleBikini,
    ProductItemLook,
} from "@hermes/api-model-product";

import {
    areAllSizeVariantsOutOfStock,
    hasSizeVariant,
    isOutOfStock,
} from "@hermes/fragments/product-utils";
import { EcomErrorCodes } from "@hermes/utils-generic/constants";

import { AddToCartCallToAction } from "../add-to-cart.state";

/**
 * If the product is out of stock, returns the proper error between generic OOS or size OOS
 * Otherwise, returns a "ok" CTA state
 */
export const getProductAddToCartCallToActions = (
    product: Product | ProductItemLook | ProductItemBundleBikini,
    ignoreSizeForError: boolean = false,
): AddToCartCallToAction => {
    if (
        (product.stock && isOutOfStock(product.stock)) ||
        (hasSizeVariant(product) && areAllSizeVariantsOutOfStock(product))
    ) {
        const shouldDisplaySizeError =
            !ignoreSizeForError && hasSizeVariant(product);

        let errorCode = shouldDisplaySizeError
            ? EcomErrorCodes.SIZE_OUT_OF_STOCK
            : EcomErrorCodes.OUT_OF_STOCK;
        /* "in" is used here instead of "instanceof" because the deserialized
         product returned from bck api is not a certified instance of the
         Product class */
        if (
            "displayMode" in product &&
            product.displayMode === BACK_IN_STOCK_DISPLAY
        ) {
            errorCode = shouldDisplaySizeError
                ? EcomErrorCodes.BACK_IN_STOCK_SIZE_OUT_OF_STOCK
                : EcomErrorCodes.BACK_IN_STOCK_OUT_OF_STOCK;
        }
        return {
            ecomError: {
                errorCode,
                enabled: true,
            },
            button: {
                enabled: false,
            },
        };
    }

    return {
        ecomError: {
            errorCode: undefined as unknown as string,
            enabled: false,
        },
        button: {
            enabled: true,
        },
    };
};
